class IntentQuestions {
	private wrapper: HTMLElement;
	private container: HTMLElement;
	private qaItems: NodeListOf<HTMLElement>;
	private currentItem: number;
	private totalItems: number;

	public constructor(target: HTMLElement) {
		this.container = target.querySelector('.container');
		this.wrapper = target.querySelector('.wrapper');
		this.qaItems = this.wrapper.querySelectorAll('.wrapper > *');

		if (this.qaItems.length === 0) {
			return;
		}

		this.currentItem = 0;
		this.totalItems = this.qaItems.length;

		this.wrapper.addEventListener('transitionend', this.onTransitionEnd);

		this.qaItems.forEach((qaItem, index) => {
			if (index < this.totalItems - 1) {
				qaItem
					.querySelectorAll('.wp-block-psg-intent-question .wp-block-button')
					.forEach((button: HTMLButtonElement) => {
						button.addEventListener(
							'click',
							() => {
								button.classList.toggle('checked');

								if (button.dataset.userIntent) {
									const userIntendInput: HTMLInputElement =
										document.querySelector(`input[name="userIntent"]`);
									userIntendInput.value = button.dataset.userIntent;
								}

								button.blur();
								this.currentItem++;
								this.qaItems[index].setAttribute('inert', '');
								this.qaItems[index + 1].removeAttribute('inert');
								this.updateItems();
								this.updateWrapperHeight();
							},
							{ once: true }
						);
					});
			}

			if (index > 0) {
				qaItem.setAttribute('inert', '');
			}
		});

		this.updateItems();
		this.updateWrapperHeight();

		window.addEventListener('resize', this.updateWrapperHeight);
		window.setTimeout(this.updateWrapperHeight, 100);
	}

	private updateItems(): void {
		this.wrapper.style.transform = this.wrapper.style.webkitTransform = `translateX(-${
			this.currentItem * 100
		}%)`;
	}

	private updateWrapperHeight = (): void => {
		if (window.innerWidth >= 786 || this.currentItem === this.totalItems - 1) {
			this.wrapper.style.height = 'auto';
			return;
		}

		this.wrapper.style.height = `${this.qaItems[this.currentItem].offsetHeight}px`;
	};

	private onTransitionEnd = (event: TransitionEvent): void => {
		if (event.propertyName === 'transform' && this.currentItem === this.totalItems - 1) {
			this.qaItems.forEach((qaItem, index) => {
				if (index < this.totalItems - 1) {
					qaItem.style.visibility = 'hidden';
				}
			});

			this.container.style.overflow = 'visible';
		}
	};
}

const initIntentQuestions = () => {
	const intentQuestions: NodeListOf<HTMLElement> = document.querySelectorAll(
		'.wp-block-psg-intent-questions'
	);

	intentQuestions.forEach((intentQuestion) => {
		new IntentQuestions(intentQuestion);
	});
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	initIntentQuestions();
} else {
	document.addEventListener('DOMContentLoaded', initIntentQuestions);
}
